import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-feature-tags/rent-objects/${formData.id}`, formData);
  },
  async update(formData) {
    return axios.put(`/rent-object-feature-tags/rent-objects/${formData.id}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-feature-tags/rent-objects/${formData.id}`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-feature-tags/${id}`);
  },
};
